module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"processing":"Processing"}}')
  delete Component.options._Ctor
}
